import React, { Fragment } from "react";
import S01Slider01 from "./S01Slider01/S01Slider01";

const G03Sliders = ({ options }) => {
  //Des
  const { slider_version } = options;

  const sliders = {
    version_1: <S01Slider01 />,
    version_2: <div>Slider Version 2</div>,
  };

  const actual_slider = sliders[slider_version] || false;
  return <Fragment>{actual_slider}</Fragment>;
};

export default G03Sliders;
